import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { DropdownButtonMenu } from './dropdownMenu';
import { TaskIcon } from './taskIcon';
import { TaskBaseProps } from './types';
import { useOverlay } from '../../../hooks/useOverlay';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../hooks/useStore';
import { Button } from '../../../lib/components/atomic/button';
import { ArrowDownIcon } from '../../../lib/icons';

type Variant = 'contained' | 'outlined' | 'icon';

export interface NewTaskButtonProps extends TaskBaseProps {
  variant?: Variant;
}

export const NewTaskButton: FC<NewTaskButtonProps> = observer(({ type }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const overlay = useOverlay();
  const { companyStore } = useStore();

  const [isMedianConfigured, setIsMedianConfigured] = useState<boolean>(false);

  const dropdownItems =
    type === 'import'
      ? [
          {
            text: t('common:EMPLOYEES'),
            onclick: () => navigate('/actions/create-import/employees/1')
          }
        ]
      : [
          {
            text: t('common:EMPLOYEES'),
            onclick: () => navigate('/exports/employee_data/1')
          },
          {
            text: t('common:RECEIPTS'),
            onclick: () => navigate('/exports/receipts/1')
          },
          {
            text: t('common:PAYROLL'),
            onclick: () => navigate('/exports/payroll_data/1')
          },
          {
            text: t('common:VOUCHER_ORDERS'),
            onclick: () => navigate('/exports/voucher_orders/1')
          }
        ];

  useEffect(() => {
    const abortController = new AbortController();
    const fn = async () => {
      try {
        setIsMedianConfigured(await companyStore.isMedianConfigured());
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error(error);
        }
      }
    };
    fn();
    return () => abortController.abort();
  }, [companyStore.settings?.payroll_system]);

  return (
    <>
      <Button
        onClick={(e) => overlay.handleClick(e)}
        disabled={type == 'import' && isMedianConfigured}
      >
        <TaskIcon type={type} />
        {t('tasks:ACTION_BUTTON', { context: type })}
        <ArrowDownIcon />
      </Button>
      <DropdownButtonMenu
        open={overlay.isOpen}
        anchorEl={overlay.anchor}
        onClose={overlay.handleClose}
        items={dropdownItems}
      />
    </>
  );
});
